import BaseService from "./BaseService.js";

class StakeholderService extends BaseService {
  get(params = {}, signal) {
    return this.apiGet({
      url: "/stakeholders",
      params,
      signal,
    });
  }

  getOptions({ filters, signal }) {
    return this.apiPost({
      url: '/query/options',
      data: {
        entity: 'Stakeholder',
        method: 'getOptions',
        mapper: { name: 'name', id: 'datastakeId', authorId: 'authorId' },
        filters,
      },
      signal,
    });
  }

  getScps(params) {
    return this.apiGet({
      url: "/scps",
      params
    });
  }

  getData(query) {
    return this.apiGet({
      url: "/stakeholder/data",
      params: query
    });
  }

  geLinking(query) {
    return this.apiGet({
      url: "/stakeholder/linking",
      params: query
    });
  }

  submit(payload) {
    if (payload.id) {
      const { id, ...data } = payload;
      return this.apiPut({
        url: `/stakeholder/${id}`,
        data,
      });
    }
    return this.apiPost({
      url: "/stakeholder",
      data: payload,
    });
  }

  publish(id) {
    return this.apiPost({
      url: `/stakeholder/${id}/publish`,
    });
  }

  getLinking(query) {
    return this.apiGet({
      url: '/stakeholder/linking',
      params: query,
    });
  }

  remove(id, data) {
    return this.apiDelete({
      url: `/stakeholder/${id}/remove`,
      data: data,
    });
  }

  getFlow(id) {
    return this.apiGet({
      url: `/dashboard/supply-chain-map/${id}`,
    })
  }
}

export default new StakeholderService();
